module.exports = __webpack_public_path__ + "img/key@2x.52b3d33a.png";